import { render, staticRenderFns } from "./web-socket.vue?vue&type=template&id=522f1eeb&scoped=true"
import script from "./web-socket.vue?vue&type=script&lang=js"
export * from "./web-socket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f1eeb",
  null
  
)

export default component.exports